var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#000000" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0A64 64 0 000 64a64 64 0 0064 63.999 64 64 0 0063.999-64A64 64 0 0063.999 0zm9.906 22.22c7.07-.014 14.576 2.427 15.833 10.438.713 4.546 1.199 12.098-9.96 17.833 8.64 2.335 11.528 7.893 11.628 13.364.236 12.843-12.232 20.697-23.455 19.443l.084-6.481c9.937 1.14 14.762-5.337 14.977-11.421.22-6.235-5.241-10.537-14.977-10.346l-.15-6.096c12.188-.904 15.622-9.343 14.104-14.03-2.077-6.419-8.71-7.604-14.573-5.347l-1.002 7.15-4.664-.15.4-11.877c2.286-1.311 6.919-2.47 11.755-2.48zM60.5 49.215V97.29c2.559-.184 6.013.705 9.142 1.205v5.268l-27.746-.017v-5.346c2.99-.41 5.75-1.094 9.02-1.169V55.972c-3.681-.063-7.145-.87-8.887-1.47v-5.13l18.471-.155z"
  }));
};